// extracted by mini-css-extract-plugin
export default {"GateBody":"extractImage_GateBody__j7PP3","SettingsContainer":"extractImage_SettingsContainer__XNJK-","Column":"extractImage_Column__PP6Vy"};